import { BaseService } from './base.service';
import { CustomResponseEntity, PaginationParams } from '../types/common';
import { InspectionsProgramSimpleDto } from '../types/dtos/inspection';
import { api } from '../client/axiosClient';

export interface CreateInspectionProgramDto {
  programVersionId: string;
  isActive: boolean;
}

/**
 * InspectionProgramService handles CRUD operations for inspection programs.
 *
 * URL Pattern: /api/v1/inspections/{inspectionId}/programs
 * Organization context is provided via X-Organization-Id header (injected by axiosClient).
 *
 * Migration: The organizationId parameter has been removed from URL paths. The backend
 * extracts organization context from the X-Organization-Id header for tenant scoping.
 *
 * @deprecated organizationId constructor parameter is deprecated and no longer used.
 */
export class InspectionProgramService extends BaseService<
  InspectionsProgramSimpleDto,
  CreateInspectionProgramDto,
  any
> {
  private basePath: string;

  /**
   * @param _organizationId - Deprecated: Organization ID (no longer used, kept for backward compatibility)
   * @param inspectionId - The inspection ID for nested resources
   */
  constructor(_organizationId: string | undefined, inspectionId: string) {
    super(`/api/v1/inspections/${inspectionId}/programs`);
    this.basePath = `/api/v1/inspections/${inspectionId}/programs`;
  }

  findAll(params?: PaginationParams): Promise<CustomResponseEntity<InspectionsProgramSimpleDto[]>> {
    return api.get(this.basePath, { params: { ...params, isActive: true } });
  }

  create(data: CreateInspectionProgramDto): Promise<CustomResponseEntity<InspectionsProgramSimpleDto>> {
    return api.post(this.basePath, data);
  }

  findByInspection(inspectionId: string): Promise<CustomResponseEntity<InspectionsProgramSimpleDto[]>> {
    return api.get(`/api/v1/inspections/${inspectionId}/programs`);
  }

  updateStatus(id: string, status: string): Promise<CustomResponseEntity<InspectionsProgramSimpleDto>> {
    return api.patch(`${this.basePath}/${id}/status`, { status });
  }
}

/**
 * Create an InspectionProgramService instance.
 * @deprecated organizationId is no longer used. Organization context comes from X-Organization-Id header.
 */
export const createInspectionProgramService = (_organizationId: string | undefined, inspectionId: string) => 
  new InspectionProgramService(_organizationId, inspectionId); 